export default {
  'profile.name': 'Import',
  'profile.title': 'Import',
  'profile.info': 'Personal information',
  'profile.edit': 'Edit information',
  'profile.code.title': 'Not right code',
  'profile.code.content': 'Do you want to go back to log in',
};
